module.exports = __webpack_public_path__ + "img/logo-mini.6662bba2.svg";